import './Home.scss';

import MetricsSection from './metrics/MetricsSection';

const Home = () => {
  return (
    <div className="Home MainSection">
      <MetricsSection />
    </div>
  );
};

export default Home;
